// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"1765d909","80":"cac80949","138":"87dfc68b","301":"9dfc550d","313":"8390b064","325":"a59bf056","329":"26482a2a","500":"6439c911","521":"8f1e411e","524":"794aa085","656":"d61fd237","696":"a7d8ae8f","783":"59cef5b0","872":"5cf34ba2","981":"baf29109"}[chunkId] + ".chunk.css";
};